import * as React from 'react';

export default function useScript(src) {
    const [loaded, setLoaded] = React.useState(false);

    React.useEffect(() => {
        let script = document.querySelector(`script[src="${src}"]`);

        if (!script) {
            script = document.createElement("script");
            script.src = src;
            script.async = true;
            const handleLoad = () => {
                script.setAttribute('loaded', true);
                setLoaded(true);
            };
            script.addEventListener("load", handleLoad);
            document.body.appendChild(script);
            return () => {
                script.removeEventListener("load", handleLoad);
            };
        }

        if (script.getAttribute('loaded') !== 'true') {
            const handleLoad = () => setLoaded(true);
            script.addEventListener("load", handleLoad);
            return () => {
                script.removeEventListener("load", handleLoad);
            };
        }

        setLoaded(true)
    }, [src]);

    return [loaded];
}